// @flow

import moment from 'moment';

import AbstractOrderModeSetting from './AbstractOrderModeSetting';


export default class TakeAwayOrderSettings extends AbstractOrderModeSetting {

}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/order/TakeAwayOrderSettings.js